var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHintSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    enableBackground: "new 0 0 88 88",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00D7B2",
    d: "M39.1340561,57.8546562c-1.0610237,0-2.0781136-0.4218712-2.8285942-1.1718636L24.7786694,45.1564865 c-1.5620022-1.5624886-1.5620022-4.0946999,0-5.657196c1.5624905-1.561512,4.0947037-1.561512,5.6571941,0l8.6981926,8.6981926 l20.2245026-20.2249813c1.5605354-1.5615158,4.0937195-1.5615158,5.6562195,0c1.5624924,1.5620022,1.5624924,4.0947018,0,5.6571941 l-23.052124,23.0530968C41.2121735,57.432785,40.1950874,57.8546562,39.1340561,57.8546562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00D7B2",
    d: "M43.9997559,88C19.7381706,88-0.0000013,68.2618256-0.0000013,44.0002441 S19.7381706-0.0000003,43.9997559-0.0000003C68.2618256-0.0000003,88,19.7386608,88,44.0002441S68.2618256,88,43.9997559,88z  M43.9997559,7.9999552c-19.8504791,0-35.9998016,16.1498146-35.9998016,36.0002899s16.1493225,35.999794,35.9998016,35.999794 c19.8509598,0,36.0002823-16.1493225,36.0002823-35.999794S63.8507156,7.9999552,43.9997559,7.9999552z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHintSuccess);
export default __webpack_public_path__ + "static/media/icon_hint_success.8ef8887f0ee137af1e38bb53e732f4d4.svg";
export { ForwardRef as ReactComponent };